import { RemediationsWebComponent } from '..';
import { RemediationsView } from '../view/RemediationsView';
import { templateRemediations } from '../view/template';
import { BaseWidgetController } from '../../widget/BaseWidgetController';
import { GetRemediationActionsResponse } from '@nirvana/shared/dtos/types/widgets/common';

export class RemediationsController extends BaseWidgetController<GetRemediationActionsResponse> {
  public component: RemediationsWebComponent;
  public view: RemediationsView;
  public viewConstructor: typeof RemediationsView;

  constructor(component: RemediationsWebComponent) {
    super(component);
    this.initialWidgetSetup({
      viewConstructor: RemediationsView,
      viewTemplate: templateRemediations,
      dataFetchMethod: this.component.dependencies.api.clients.Widgets.getRemediationActions,
    });
  }
}
